export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7137__30_DAY_ROLLING': '30 Day Rolling',
    '_202_DAILY': 'Daily',
    '_709_DATE_RANGE': 'Date Range',
    '_7151_DEFAULT': 'Default',
    '_822_DRILL_PATH': 'Drill Path',
    '_7152_FAVOURITE': 'Favourite',
    '_7136_GRID': 'Grid',
    '_7150_IMAGE': 'Image',
    '_7391_LEGEND': 'Legend',
    '_7146_METRIC_NAME': 'Metric Name',
    '_204_MONTHLY': 'Monthly',
    '_7147_NEGATIVE_PERFORMANCE': 'Negative Performance',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7148_POSITIVE_PERFORMANCE': 'Positive Performance',
    '_205_QUARTERLY': 'Quarterly',
    '_7149_THRESHOLD': 'Threshold',
    '_989_TREND': 'Trend',
    '_203_WEEKLY': 'Weekly',
    '_7132_YEARLY': 'Yearly',
    '_646_YYYY_MM_DD': 'yyyy-mm-dd',
    '_832_MARKET': 'Market',
    '_11081_THIS_QUEUE_IS_NOT_PART_OF_THE_SUPERGROUP': 'This queue is not part of the SuperGroup',
    '_11082_THIS_SUPERGROUP_IS_NOT_ASSOCIATED_TO_THE_QUEUE': 'This supergroup is not associated to the queue',
    '_11165_CUSTOMIZE': 'Customize',
    '_801_PILLARS': 'Pillars',
    '_7511_COLUMNS': 'Columns',
    '_527_METRICS': 'Metrics'
};
